export const TransferTitles: Dictionary<string> = {
  processing: '송금 진행 중, 송금 완료 대기 (Status 02)',
  failed: '송금 실패, 특이 송금 (Status 03)',
  complete: '송금 완료 (Status 10)',
  aml: 'AML Filtered (Status -4)',
  all: 'All',
  analogue: "아날로그 송금(고객에게는 '송금진행중'으로 표시됩니다.)"
}
